/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: InfoDialog
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 17Oct2022 craig File created.
 \******************************************************************************/
import {Button, Modal} from "react-bootstrap";
import React from "react";

interface DialogProps {
    title:string,
    body: React.ReactNode,
    show:boolean,
    showHide:any
}
export const InfoDialog: React.FC<DialogProps> = ({title, body, show, showHide}: DialogProps) => {
    return (
        <Modal show={show}>
            <Modal.Header closeButton={true} onClick={showHide}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Button variant={"secondary"} onClick={showHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}